import { camelcaseKeys } from 'src/utils/camelize-keys';
import { timestampToDate } from 'src/utils/dateFormatter';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import { removeReadOnlyFields } from 'src/utils/fieldNormalizers';

import { InviteLink, Platform, PlatformSettings } from './_types';

const readOnlyFields = ['platform_roles'];

export function normalizePlatform(platform): Platform {
  const normalized = camelcaseKeys(platform, { deep: true });

  return {
    ...normalized,
    createdAt: timestampToDate(normalized.createdAt),
    updatedAt: timestampToDate(normalized.updatedAt),
  };
}

export function denormalizePlatform(platform): Platform {
  const decamelized = decamelizeKeys(platform, { deep: true });
  removeReadOnlyFields(decamelized, readOnlyFields);

  // Remove the auto-decamelized version
  delete decamelized.twilio10_dlc_excluded;

  return {
    ...decamelized,
    // Handle special case for twilio10dlcExcluded
    ...(platform.twilio10dlcExcluded !== undefined && {
      twilio_10dlc_excluded: platform.twilio10dlcExcluded,
    }),
  };
}

export function normalizePlatformSettings(platformSettings): PlatformSettings {
  return camelcaseKeys(platformSettings, { deep: true });
}

export function denormalizePlatformSettings(
  platformSettings
): PlatformSettings {
  const decamelized = decamelizeKeys(platformSettings, { deep: true });
  removeReadOnlyFields(decamelized, readOnlyFields);

  return decamelized;
}

export function normalizeInviteLink(inviteLink): InviteLink {
  return camelcaseKeys(inviteLink, { deep: true });
}
